var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('div', {
    staticClass: "board-container"
  }, [_c('div', {
    staticClass: "board-table board-table--solid",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    staticClass: "num",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("번호")]), _c('div', {
    staticClass: "tit",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("제목")]), _c('div', {
    staticClass: "date",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("작성일")]), _c('div', {
    staticClass: "num",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("조회")])])]), _c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, _vm._l(_vm.notices, function (notice, index) {
    return _c('div', {
      key: "notice-".concat(index),
      attrs: {
        "role": "row"
      }
    }, [_c('div', {
      staticClass: "num",
      attrs: {
        "role": "cell"
      }
    }, [_c('v-icon', [_vm._v(_vm._s(_vm.mdiAlertCircleOutline))])], 1), _c('div', {
      staticClass: "tit font-weight-bold",
      attrs: {
        "role": "cell"
      }
    }, [_c('a', {
      on: {
        "click": function click($event) {
          return _vm.showBoard(notice);
        }
      }
    }, [_vm._v(_vm._s(notice.subject))])]), _c('div', {
      staticClass: "date font-weight-bold",
      attrs: {
        "role": "cell"
      }
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(notice.createdAt.toDate()))])]), _c('div', {
      staticClass: "num font-weight-bold",
      attrs: {
        "role": "cell"
      }
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(notice.viewCount))])])]);
  }), 0), _c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, _vm._l(_vm.boards, function (board, index) {
    return _c('div', {
      key: "board-".concat(index),
      attrs: {
        "role": "row"
      }
    }, [_c('div', {
      staticClass: "num",
      attrs: {
        "role": "cell"
      }
    }, [_vm._v(_vm._s(_vm.summary.totalCount - _vm.skip - index))]), _c('div', {
      staticClass: "tit",
      attrs: {
        "role": "cell"
      }
    }, [_c('a', {
      on: {
        "click": function click($event) {
          return _vm.showBoard(board);
        }
      }
    }, [_vm._v(_vm._s(board.subject))])]), _c('div', {
      staticClass: "date",
      attrs: {
        "role": "cell"
      }
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(board.createdAt.toDate()))])]), _c('div', {
      staticClass: "num",
      attrs: {
        "role": "cell"
      }
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(board.viewCount))])])]);
  }), 0)]), _c('div', {
    staticClass: "board-buttons board-buttons--center"
  }, [_vm._t("write-button")], 2), _c('div', {
    staticClass: "board-bottom"
  }, [_vm._t("pagination")], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }